import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { WALKSCORE_LEGEND } from '../../../constants/legends';
import { walkscoreMetricSections } from '../../../constants/variables';
import styles from '../FilterSidebar.module.css';

// DA-14919: WalkScore — переключатель крашенной метрики. Все скоры (15 категорий + 5 групп +
// общий) лежат атрибутами одного тайла; выбор меняет только атрибут в fill-color (Map.jsx).
// Список метрик вынесен в variables.js (walkscoreMetricSections) — единый источник
// с заголовком экспорта растра (exportTitle слоя WalkScore, DA-15019).
const METRIC_SECTIONS = walkscoreMetricSections;
// Оверзумы: база z10 + усреднённые роллапы z9..6; 'auto' → функция берёт z-1.
const H3_ZOOMS = [ 6, 7, 8, 9, 10, 'auto' ];
const WalkscoreFilterComponent = ({ onChangeMapFilters, walkscoreMetric, walkscoreH3Zoom }) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleMetricChange = ({ target: { value } }) => {
        onChangeMapFilters('walkscoreMetric', value);
    };
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('walkscoreH3Zoom', value);
    };
    const toggleH3Zoom = () => setIsH3ZoomExpanded(!isH3ZoomExpanded);

    return (
        <div>
            {METRIC_SECTIONS.map(section => (
                <div key={i18n._(section.title)}>
                    <div className={styles.legHead}>{i18n._(section.title)}:</div>
                    <StandardRadioGroup
                        value={walkscoreMetric}
                        onChange={handleMetricChange}
                    >
                        {section.items.map(({ key, label }) => (
                            <FormControlLabel
                                key={key}
                                className={styles.isochroneFilterLabel}
                                control={
                                    <Radio
                                        checked={walkscoreMetric === key}
                                        onChange={handleMetricChange}
                                        value={key}
                                        className={classnames(
                                            styles.isochroneFilterInput, {
                                                [styles.checkedIsochroneFilterInput]: walkscoreMetric === key,
                                            }
                                        )}
                                        size="small"
                                    />
                                }
                                label={i18n._(label)}
                            />
                        ))}
                    </StandardRadioGroup>
                </div>
            ))}

            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(walkscoreH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {H3_ZOOMS.map(zoom => (
                        <FormControlLabel
                            key={zoom}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={String(walkscoreH3Zoom) === String(zoom)}
                                    onChange={handleH3ZoomChange}
                                    value={String(zoom)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: String(walkscoreH3Zoom) === String(zoom),
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={zoom}
                        />
                    ))}
                </StandardRadioGroup>
            )}

            <LegendRenderer config={WALKSCORE_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { walkscoreMetric, walkscoreH3Zoom } }) => ({ walkscoreMetric, walkscoreH3Zoom });
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(WalkscoreFilterComponent);

// Второй аргумент — id слоя (filterIds сверяет по layer.id, не по label).
export const WalkscoreFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    'WalkScore'
);
